import { Vue, Options } from 'vue-class-component';
import {
CallingCodeDTO,
  EntrancePlantDetailDTO,
  EntrancePlantStructureCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import CodeRecap from '../../CodeRecap/CodeRecap.vue';
import { SET_SELECTED_PLANT_ID } from '@/core/store/action-types';

@Options({
  name: 'DialogEntrancePlantCreateBRFACodeExample',
  components: {
    CodeRecap
  },
  props: {
    plant: {
      required: true,
      type: Object as () => EntrancePlantDetailDTO,
    },
    structureCreate: {
      required: true,
      type: Object as () => EntrancePlantStructureCreateDTO,
    },
    plantId: {
      type: Number,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    plant: function (newValue) {
      if (newValue) this.initializeData();
    },
  },
  emits: ['is-loading', 'onBack', 'onNext', 'plant-edited'],
  computed: {},
})
export default class DialogEntrancePlantCreateBRFACodeExample extends Vue {
  plant!: EntrancePlantDetailDTO;
  plantId!: number;
  structureCreate!: EntrancePlantStructureCreateDTO;
  recapCode = new CallingCodeDTO();
  
  mounted(): void {
    this.initializeData();
  }

  async initializeData() {
    if (!this.plantId) return;
    this.$emit('is-loading', true);

    try {
      this.recapCode = await plantsClient.callingcoderecap(this.plantId);
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 6000,
      });
    } finally {
      this.$emit('is-loading', false);
    }
  }


  handleBackButton() {
    this.$emit('onBack', 'DialogEntrancePlantCreateSetupBuildingBRFA');
  }

  async handleNextButton() {
    this.$emit('is-loading', true);
    
    try {
      this.goToPlantDetail();
    } finally {
      this.$emit('is-loading', false);
    }
  }

  goToPlantDetail() {
    this.$nextTick(async () => {
      await this.$store.dispatch(SET_SELECTED_PLANT_ID, this.plantId);
      this.$router.push({
        name: 'page-entranceplant-dashboard',
        params: { plantId: this.plantId.toString() ?? '' },
      });
      this.$toast.add({
        severity: 'success',
        summary: this.$t('AppResource.PlantCreated'),
        closable: false,
        life: 3000,
      });
      const summary = this.$t('general.synced');
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: summary,
          closable: false,
          life: 3000,
        });
      }, 1500);
    });
  }

}
